// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__a11nv","tab_active":"Tab_tab_active__Swdus","tab_disabled":"Tab_tab_disabled__YTbsy","tab_special":"Tab_tab_special__q7LbS"};